import { ReactComponent as FlagIcon } from "./svg/fi-flag.svg";
import "../flag-icon.scss";

export const FIFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
